export { AzureKeyCredential } from "./azureKeyCredential.js";
export { isKeyCredential } from "./keyCredential.js";
export { AzureNamedKeyCredential, isNamedKeyCredential, } from "./azureNamedKeyCredential.js";
export { AzureSASCredential, isSASCredential } from "./azureSASCredential.js";
export { isTokenCredential, } from "./tokenCredential.js";
//# sourceMappingURL=index.js.map